var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-confirmed",attrs:{"id":"calendar-confirmed"}},[_vm._m(0),_c('CalendarListing',{attrs:{"itemsByDate":_vm.confirmedByDate,"timezone":_vm.timezone,"me":_vm.me},on:{"modal":_vm.doModal}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('span',[_vm._v("Confirmed")])])
}]

export { render, staticRenderFns }